/**
 * The days of a recurring shift, expanded exactly like the backend
 * (`shiftServiceImpl.expandRecurringDates`): DAILY every day, WEEKDAYS Monday to Friday,
 * CUSTOM_WEEKDAYS the chosen ISO weekdays (1 = Monday ... 7 = Sunday), WEEKLY the same
 * weekday; one day without a recurrence or with fewer than two repetitions.
 */
import { addDays, addWeeks } from 'date-fns';

export function expandRecurrenceDates(
  start: Date,
  recurrenceType: string,
  repetitions: number | undefined,
  weekdays: number[] = []
): Date[] {
  if (!recurrenceType || recurrenceType === 'NONE' || !repetitions || repetitions <= 1) {
    return [start];
  }
  const dates: Date[] = [];
  switch (recurrenceType) {
    case 'DAILY':
      for (let i = 0; i < repetitions; i++) dates.push(addDays(start, i));
      return dates;
    case 'WEEKLY':
      for (let i = 0; i < repetitions; i++) dates.push(addWeeks(start, i));
      return dates;
    case 'WEEKDAYS':
    case 'CUSTOM_WEEKDAYS': {
      // JS getDay(): 0 = Sunday; ISO 7 (Sunday) maps to 0.
      const allowed =
        recurrenceType === 'WEEKDAYS' ? new Set([1, 2, 3, 4, 5]) : new Set(weekdays.map((iso) => iso % 7));
      if (allowed.size === 0) return [start];
      for (let offset = 0; dates.length < repetitions; offset++) {
        const day = addDays(start, offset);
        if (allowed.has(day.getDay())) dates.push(day);
      }
      return dates;
    }
    default:
      return [start];
  }
}
